import { proxy } from 'valtio';

/** Persisted history date ranges (measurements + alarms) keyed by module id. */
export interface HistoryDateRangePersisted {
  from: string;
  to: string;
}

interface GlobalState {
  deviceInterfaceOpen: boolean[];
  secondaryParameterOpen: boolean;
  companyLogoUrl?: string;
  historyDateRangeByModuleId: Record<string, HistoryDateRangePersisted>;
}

export const initialGlobalState: GlobalState = {
  deviceInterfaceOpen: [false, false, false, false],
  secondaryParameterOpen: false,
  companyLogoUrl: undefined,
  historyDateRangeByModuleId: {},
};

export const globalState = proxy<GlobalState>(initialGlobalState);
